module.exports = __webpack_public_path__ + "img/title_img.ac656c5c.png";